import { inject, injectable } from 'inversify';

import { TYPES as HTTP_TYPES } from './modules/http';
import { TYPES } from '@/engine/ioc';
import { CORE_TYPES } from './modules/core';

import type { AuthInterceptor } from './AuthInterceptor';
import type { IHttpService } from './modules/http';
import type { CoreModule } from './modules/core/module/Core.module.ts';
import type { ObservabilityLoggerService } from '@/app.obresvability/loggerService/observabilityLogger.service.ts';

const { HttpService: HttpServiceType } = HTTP_TYPES;
const { AuthInterceptor: AuthInterceptorType } = TYPES;

interface IAppBootstrapper {
  bootstrap: () => void;
}

@injectable()
export class AppBootstrapper implements IAppBootstrapper {
  private readonly _httpService: IHttpService;

  private readonly _authInterceptor: AuthInterceptor;

  private readonly _coreModule: CoreModule;

  private readonly _loggerService: ObservabilityLoggerService;

  public constructor(
    @inject(HttpServiceType) httpService: IHttpService,
    @inject(AuthInterceptorType) authInterceptor: AuthInterceptor,
    @inject(CORE_TYPES.CoreModule) coreModule: CoreModule,
    @inject(CORE_TYPES.ObservabilityLoggerService) loggerService: ObservabilityLoggerService
  ) {
    this._httpService = httpService;
    this._authInterceptor = authInterceptor;
    this._coreModule = coreModule;
    this._loggerService = loggerService;
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public async bootstrap(): Promise<void> {
    this._httpService.addResponseInterceptor(this._authInterceptor);
    await this._coreModule.init(); // TODO: Implement a way for each module initialization
    this._loggerService.init();
  }
}
